import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StoresService {

  updateStore(id, status) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/stores/${id}`, status, httpOptions);
  }

  getStore() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/stores/owners/1`, httpOptions);
  }

  getPaymentMethods(storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/stores/${storeId}/payment-methods?status=TRUE&type=debito`, httpOptions);
  }

  getShedule(storeId,day){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/stores/${storeId}/schedules?day=${day}`, httpOptions);
  }

  getPaymentMethodsByStore(storeId: number,type:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/stores/${storeId}/payment-methods?type=${type}`, httpOptions);
  }

  constructor(private http: HttpClient) { }
}
